"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FOREVER_LIMIT_FREQUENCY = exports.NOT_LIMIT_FREQUENCY = exports.LIMIT_FREQUENCY_STRAGEGY = exports.MAX_THRESHOLD = exports.MIDDLE_THRESHOLD = exports.MIN_THRESHOLD = exports.LimitFrequencyLevel = exports.MessagePriority = void 0;
/**
 * 消息优先级，目前分3级
 */
var MessagePriority;
(function (MessagePriority) {
    /**
     * 默认优先级（不限频）。比如数据类消息Command.USER_CHANGES
     */
    MessagePriority[MessagePriority["HIGH"] = 0] = "HIGH";
    /**
     * 中优先级，可节流限制，但是数据不能丢。比如人员协同消息
     */
    MessagePriority[MessagePriority["MIDDLE"] = 1] = "MIDDLE";
    /**
     * 低优先级，可节流限制，可丢弃。比如光标消息
     */
    MessagePriority[MessagePriority["LOW"] = 2] = "LOW";
})(MessagePriority || (MessagePriority = {}));
exports.MessagePriority = MessagePriority;
/**
 * 限频级别
 *
 * @enum {number}
 */
var LimitFrequencyLevel;
(function (LimitFrequencyLevel) {
    /**
     * 当前房间人数小于 MIN_THRESHOLD, 不限频
     */
    LimitFrequencyLevel[LimitFrequencyLevel["LOW"] = 0] = "LOW";
    /**
     * 中等限频，当前房间人数小于 MIDDLE_THRESHOLD，开始限频
     */
    LimitFrequencyLevel[LimitFrequencyLevel["MIDDLE"] = 1] = "MIDDLE";
    /**
     * 高等限频，当前房间人数小于 MIDDLE_THRESHOLD，限频间隔比 MIDDLE 长了一点
     */
    LimitFrequencyLevel[LimitFrequencyLevel["HIGH"] = 2] = "HIGH";
    /**
     * 最高等级限频，间隔时间最长，MessagePriority.LOW 丢弃
     */
    LimitFrequencyLevel[LimitFrequencyLevel["HIGHEST"] = 3] = "HIGHEST";
})(LimitFrequencyLevel || (LimitFrequencyLevel = {}));
exports.LimitFrequencyLevel = LimitFrequencyLevel;
/**
 * 不受限频的最小阈值
 */
var MIN_THRESHOLD = 20;
exports.MIN_THRESHOLD = MIN_THRESHOLD;
/**
 * 第一个限频区间上限
 */
var MIDDLE_THRESHOLD = 50;
exports.MIDDLE_THRESHOLD = MIDDLE_THRESHOLD;
/**
 * 第二个限频区间上限
 */
var MAX_THRESHOLD = 100;
exports.MAX_THRESHOLD = MAX_THRESHOLD;
var NOT_LIMIT_FREQUENCY = 0;
exports.NOT_LIMIT_FREQUENCY = NOT_LIMIT_FREQUENCY;
var FOREVER_LIMIT_FREQUENCY = Number.MAX_SAFE_INTEGER;
exports.FOREVER_LIMIT_FREQUENCY = FOREVER_LIMIT_FREQUENCY;
/**
 * 限频策略为二维数据，一维坐标为 MessagePriority，优先级从高（HIGH）->低（LOW）。
 * 二维坐标为 LimitFrequencyLevel，级别从高（HIGHEST）->低（LOW）。
 * 具体数值请参考该路径下的 README
 */
var LIMIT_FREQUENCY_STRAGEGY = [
    [0, 0, 0, 0],
    [0, 5 * 1000, 10 * 1000, 20 * 1000],
    [0, 10 * 1000, 20 * 1000, FOREVER_LIMIT_FREQUENCY]
];
exports.LIMIT_FREQUENCY_STRAGEGY = LIMIT_FREQUENCY_STRAGEGY;
